import * as moment from 'moment';
import { ActionType, getType } from 'typesafe-actions';

import { combineReducers } from 'redux';
import { EventFilter } from 'types/events';
import * as actions from './actions';

export interface IEventsState {
  readonly date: moment.Moment | null;
  readonly eventsSearchActual: string;
  readonly eventsSearchText: string;
  readonly filter: EventFilter;
  readonly countryFilter: string;
  readonly countryFilterLabel: string;
  readonly countrySearchActual: string;
  readonly countrySearchText: string;
}

export type EventsAction = ActionType<typeof actions>;

const initialState: IEventsState = {
  countryFilter: '',
  countryFilterLabel: '',
  countrySearchActual: '',
  countrySearchText: '',
  date: null,
  eventsSearchActual: '',
  eventsSearchText: '',
  filter: 'recent'
};

export default combineReducers<IEventsState, EventsAction>({
  countryFilter: (state = initialState.countryFilter, action) => {
    if (action.type === getType(actions.setCountry)) {
      return action.payload.country;
    }
    return state;
  },
  countryFilterLabel: (state = initialState.countryFilter, action) => {
    if (action.type === getType(actions.setCountry)) {
      return action.payload.label;
    }
    return state;
  },
  countrySearchActual: (state = initialState.countrySearchActual, action) => {
    if (
      action.type === getType(actions.search) &&
      action.payload.type === 'country'
    ) {
      return action.payload.text;
    }
    return state;
  },
  countrySearchText: (state = initialState.countrySearchText, action) => {
    if (
      action.type === getType(actions.searchRequest) &&
      action.payload.type === 'country'
    ) {
      return action.payload.text;
    }
    return state;
  },
  date: (state = initialState.date, action) => {
    switch (action.type) {
      case getType(actions.changeDate): {
        return action.payload.date;
      }
      default: {
        return state;
      }
    }
  },
  eventsSearchActual: (state = initialState.eventsSearchActual, action) => {
    if (
      action.type === getType(actions.search) &&
      action.payload.type === 'event'
    ) {
      return action.payload.text;
    }
    return state;
  },
  eventsSearchText: (state = initialState.eventsSearchText, action) => {
    if (
      action.type === getType(actions.searchRequest) &&
      action.payload.type === 'event'
    ) {
      return action.payload.text;
    }
    return state;
  },
  filter: (state = initialState.filter, action) => {
    if (action.type === getType(actions.changeFilter)) {
      return action.payload.filter;
    }
    return state;
  }
});



// WEBPACK FOOTER //
// ./src/store/modules/events/reducer.ts